<script setup lang="ts">
import { baseUrl, padWithZeros } from '@/core/utils'
import { computed, ref } from 'vue'
import { SAMUDKOY } from '@/modules/simakatra/constants'
import { useAudio } from '@/core/composables/useAudio'

useAudio('backgroundmusic').pause()

const props = defineProps<{
  page: number
}>()

const toggleTH = ref(true)
const toggleEN = ref(true)

const srcPageTH = computed(() => {
  const langPages = [1, 2, 3, 4, 61, 68, 69]
  let langPath = langPages.includes(props.page) ? 'th/' : ''
  return baseUrl(`/images/samudkoy-pages/${langPath + padWithZeros(props.page, 2)}.png`)
})

const srcPageEN = computed(() => {
  const langPages = [1, 2, 3, 4, 61, 68, 69]
  let langPath = langPages.includes(props.page) ? 'en/' : ''
  return baseUrl(`/images/samudkoy-pages/${langPath + padWithZeros(props.page, 2)}.png`)
})

const srcPopupTH = computed(() =>
  SAMUDKOY.TRANSLATE_TH_PAGES.includes(props.page)
    ? baseUrl(`/images/samudkoy-popup/th/${padWithZeros(props.page, 2)}.png`)
    : ''
)

const srcPopupEN = computed(() =>
  SAMUDKOY.TRANSLATE_EN_PAGES.includes(props.page)
    ? baseUrl(`/images/samudkoy-popup/en/${padWithZeros(props.page, 2)}.png`)
    : ''
)

function handlePointerdown(lang: string) {
  if (lang == 'th') toggleTH.value = !toggleTH.value
  if (lang == 'en') toggleEN.value = !toggleEN.value
}
</script>

<template>
  <div class="page-preview container">
    <div class="column left" @pointerdown="handlePointerdown('th')">
      <div class="title">{{ srcPageTH }} &nbsp;&nbsp;&nbsp;{{ srcPopupTH }}</div>
      <img class="page" :src="srcPageTH" />
      <img v-if="srcPopupTH" v-show="toggleTH" class="popup" :src="srcPopupTH" />
    </div>
    <div class="column right" @pointerdown="handlePointerdown('en')">
      <div class="title">{{ srcPageEN }} &nbsp;&nbsp;&nbsp;{{ srcPopupEN }}</div>
      <img class="page" :src="srcPageEN" />
      <img v-if="srcPopupEN" v-show="toggleEN" class="popup" :src="srcPopupEN" />
    </div>
  </div>
</template>

<style scoped>
.container {
  display: block;
  width: 2700px;
  height: 970px;
  box-sizing: content-box;
  overflow: hidden;
  margin: 2rem 0;
  border-bottom: 1px dashed gray;
  /* border: 1px solid #f00; */
}

.column {
  position: relative;
  width: 1350px;
  height: 970px;
  float: left;
  /* border: 1px solid #0f0; */
}

.title {
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 1.25em;
}

.page {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  rotate: 90deg;
}

.popup {
  position: absolute;
}
</style>
